/* MEATBROS · pages éditoriales · visionneuse photo (galerie des prestations, mosaïque Événementiel)
   Déclencheur : [data-mb-visionneuse="<groupe>"][data-mb-index="<n>"]
   Données : <script type="application/json" id="MbVisionneuse-<groupe>">{"titre":"…","photos":[{src,srcset,largeur,hauteur,alt,titre,texte}]}</script>
   <dialog> modal, flèches, clavier (← → Début Fin Échap), balayage tactile, compteur « 1 / 5 », focus rendu au déclencheur. */
(function () {
  'use strict';

  var TAILLES = '(max-width: 640px) 100vw, calc(100vw - 180px)';
  var natif = typeof window.HTMLDialogElement === 'function' && typeof document.createElement('dialog').showModal === 'function';
  var dialog, image, titre, texte, compteur, annonce, precedent, suivant, fermer, scene;
  var photos = [], position = 0, declencheur = null, departX = null, departY = null;

  var icones = {
    fermer: '<svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true" focusable="false"><path d="M5 5l10 10M15 5L5 15" stroke-linecap="round"/></svg>',
    precedent: '<svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true" focusable="false"><path d="M12.5 4.5L7 10l5.5 5.5" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    suivant: '<svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true" focusable="false"><path d="M7.5 4.5L13 10l-5.5 5.5" stroke-linecap="round" stroke-linejoin="round"/></svg>'
  };

  function construire() {
    if (dialog) return;
    dialog = document.createElement('dialog');
    dialog.className = 'mb-visionneuse';
    if (!natif) { dialog.setAttribute('role', 'dialog'); dialog.setAttribute('aria-modal', 'true'); }
    dialog.innerHTML =
      '<div class="mb-visionneuse__barre">' +
        '<p class="mb-visionneuse__compteur" aria-hidden="true"></p>' +
        '<button type="button" class="mb-visionneuse__fermer" autofocus>' + icones.fermer + '<span class="visually-hidden">Fermer la visionneuse</span></button>' +
      '</div>' +
      '<div class="mb-visionneuse__scene">' +
        '<button type="button" class="mb-visionneuse__nav mb-visionneuse__nav--prec">' + icones.precedent + '<span class="visually-hidden">Photo précédente</span></button>' +
        '<figure class="mb-visionneuse__figure">' +
          '<div class="mb-visionneuse__cadre"><img class="mb-visionneuse__img" alt="" decoding="async"></div>' +
          '<figcaption class="mb-visionneuse__legende"><strong class="mb-visionneuse__titre"></strong><span class="mb-visionneuse__texte"></span></figcaption>' +
        '</figure>' +
        '<button type="button" class="mb-visionneuse__nav mb-visionneuse__nav--suiv">' + icones.suivant + '<span class="visually-hidden">Photo suivante</span></button>' +
      '</div>' +
      '<p class="visually-hidden" aria-live="polite" aria-atomic="true"></p>';
    document.body.appendChild(dialog);

    image = dialog.querySelector('.mb-visionneuse__img');
    titre = dialog.querySelector('.mb-visionneuse__titre');
    texte = dialog.querySelector('.mb-visionneuse__texte');
    compteur = dialog.querySelector('.mb-visionneuse__compteur');
    annonce = dialog.querySelector('[aria-live]');
    precedent = dialog.querySelector('.mb-visionneuse__nav--prec');
    suivant = dialog.querySelector('.mb-visionneuse__nav--suiv');
    fermer = dialog.querySelector('.mb-visionneuse__fermer');
    scene = dialog.querySelector('.mb-visionneuse__scene');

    fermer.addEventListener('click', fermerVisionneuse);
    precedent.addEventListener('click', function () { afficher(position - 1, true); });
    suivant.addEventListener('click', function () { afficher(position + 1, true); });

    image.addEventListener('load', function () { dialog.classList.remove('mb-visionneuse--charge'); });
    image.addEventListener('error', function () { dialog.classList.remove('mb-visionneuse--charge'); });

    /* Échap : événement natif « cancel » ; on ferme nous-mêmes pour rendre le focus. */
    dialog.addEventListener('cancel', function (e) { e.preventDefault(); fermerVisionneuse(); });
    dialog.addEventListener('close', apresFermeture);

    dialog.addEventListener('keydown', function (e) {
      var plusieurs = photos.length > 1;
      switch (e.key) {
        case 'ArrowLeft': case 'Left':
          if (plusieurs) { e.preventDefault(); afficher(position - 1, true); }
          break;
        case 'ArrowRight': case 'Right':
          if (plusieurs) { e.preventDefault(); afficher(position + 1, true); }
          break;
        case 'Home':
          if (plusieurs) { e.preventDefault(); afficher(0, true); }
          break;
        case 'End':
          if (plusieurs) { e.preventDefault(); afficher(photos.length - 1, true); }
          break;
        case 'Escape': case 'Esc':
          if (!natif) { e.preventDefault(); fermerVisionneuse(); }
          break;
        case 'Tab':
          if (!natif) { garderFocus(e); }
          break;
      }
    });

    /* Clic hors de la photo (fond de la scène) : fermeture. */
    dialog.addEventListener('click', function (e) {
      var cible = e.target;
      if (cible === dialog || cible === scene || (cible.classList && (cible.classList.contains('mb-visionneuse__figure') || cible.classList.contains('mb-visionneuse__cadre')))) {
        fermerVisionneuse();
      }
    });

    /* Balayage tactile. */
    scene.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) { departX = null; return; }
      departX = e.touches[0].clientX;
      departY = e.touches[0].clientY;
    }, { passive: true });
    scene.addEventListener('touchend', function (e) {
      if (departX === null || photos.length < 2) return;
      var dx = e.changedTouches[0].clientX - departX;
      var dy = e.changedTouches[0].clientY - departY;
      departX = null;
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.3) {
        afficher(position + (dx < 0 ? 1 : -1), true);
      }
    }, { passive: true });
  }

  function garderFocus(e) {
    var focusables = Array.prototype.filter.call(dialog.querySelectorAll('button'), function (b) {
      return b.offsetParent !== null && window.getComputedStyle(b).visibility !== 'hidden';
    });
    if (!focusables.length) return;
    var premier = focusables[0], dernier = focusables[focusables.length - 1];
    if (e.shiftKey && document.activeElement === premier) { e.preventDefault(); dernier.focus(); }
    else if (!e.shiftKey && document.activeElement === dernier) { e.preventDefault(); premier.focus(); }
  }

  function indexValide(i) {
    var n = photos.length;
    return ((i % n) + n) % n;
  }

  function precharger(i) {
    if (photos.length < 2) return;
    var p = photos[indexValide(i)];
    var img = new Image();
    if (p.srcset) { img.sizes = TAILLES; img.srcset = p.srcset; }
    img.src = p.src;
  }

  function afficher(i, annoncer) {
    if (!photos.length) return;
    position = indexValide(i);
    var p = photos[position];
    var n = photos.length;

    dialog.classList.add('mb-visionneuse--charge');
    image.removeAttribute('srcset');
    image.removeAttribute('width');
    image.removeAttribute('height');
    if (p.largeur && p.hauteur) { image.setAttribute('width', p.largeur); image.setAttribute('height', p.hauteur); }
    if (p.srcset) { image.sizes = TAILLES; image.srcset = p.srcset; }
    image.src = p.src;
    image.alt = p.alt || p.titre || '';
    if (image.complete && image.naturalWidth) dialog.classList.remove('mb-visionneuse--charge');

    titre.textContent = p.titre || '';
    texte.textContent = p.texte || '';
    texte.hidden = !p.texte;
    compteur.textContent = (position + 1) + ' / ' + n;

    if (annoncer) {
      annonce.textContent = 'Photo ' + (position + 1) + ' sur ' + n + (p.titre ? ' : ' + p.titre : '') + (p.texte ? '. ' + p.texte : '');
    }
    precharger(position + 1);
    precharger(position - 1);
  }

  function ouvrir(bouton) {
    var groupe = bouton.getAttribute('data-mb-visionneuse');
    var source = groupe && document.getElementById('MbVisionneuse-' + groupe);
    if (!source) return false;
    var donnees;
    try { donnees = JSON.parse(source.textContent); } catch (err) { return false; }
    if (!donnees || !donnees.photos || !donnees.photos.length) return false;

    construire();
    photos = donnees.photos;
    declencheur = bouton;
    dialog.setAttribute('aria-label', donnees.titre ? 'Visionneuse photo : ' + donnees.titre : 'Visionneuse photo');
    dialog.classList.toggle('mb-visionneuse--seule', photos.length < 2);
    annonce.textContent = '';
    afficher(parseInt(bouton.getAttribute('data-mb-index'), 10) || 0, false);

    document.documentElement.classList.add('mb-visionneuse-ouverte');
    if (natif) {
      if (!dialog.open) dialog.showModal();
      fermer.focus();
    } else {
      dialog.setAttribute('open', '');
      fermer.focus();
    }
    return true;
  }

  function fermerVisionneuse() {
    if (!dialog) return;
    if (natif) {
      if (dialog.open) dialog.close();
    } else if (dialog.hasAttribute('open')) {
      dialog.removeAttribute('open');
      apresFermeture();
    }
  }

  function apresFermeture() {
    document.documentElement.classList.remove('mb-visionneuse-ouverte');
    image.removeAttribute('srcset');
    image.removeAttribute('src');
    var retour = declencheur;
    declencheur = null;
    if (retour && document.body.contains(retour)) {
      try { retour.focus({ preventScroll: true }); } catch (err) { retour.focus(); }
    }
  }

  document.addEventListener('click', function (e) {
    var bouton = e.target && e.target.closest ? e.target.closest('[data-mb-visionneuse]') : null;
    if (!bouton) return;
    if (ouvrir(bouton)) e.preventDefault();
  });

  /* Éditeur de thème : fermer la visionneuse si sa section est rechargée. */
  document.addEventListener('shopify:section:unload', function () { fermerVisionneuse(); });
})();
